const tableHeaders = [
  {
    label: 'Decision',
    key: 'reviewResult',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'HQ Reason',
    key: 'reviewReason',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Updated',
    key: 'reviewedAt',
    filter: 'date',
    defaultSort: true,
    sortable: false,
  },
];

export default () => tableHeaders;
